import { CustomValidator } from "../../common/validation/types";
import { EditionValuesType } from "./EditionCommonStore";

const EDITION_TYPE_SINGLE_WORK = "Single Work";

export const editionTypeWorksValidator: CustomValidator<EditionValuesType> = {
  name: "editionTypeWorksValidator",
  validate(values, langStore) {
    const errors: Record<string, { message: string; fieldLabel: string }> = {};
    const cardErrors: Record<string, string[]> = {};

    const worksCount = values.showWorks?.length || 0;
    const editionTypeId = values.showEditionType?.id;

    if (worksCount === 1 && editionTypeId !== EDITION_TYPE_SINGLE_WORK) {
      errors.editionType = {
        message: langStore.editionTypeSingleWorkRequired,
        fieldLabel: langStore.EditionEditionTypeLabel,
      };
    }

    if (worksCount > 1 && editionTypeId === EDITION_TYPE_SINGLE_WORK) {
      errors.editionType = {
        message: langStore.editionTypeSingleWorkNotAllowed,
        fieldLabel: langStore.EditionEditionTypeLabel,
      };
    }

    return { errors, cardErrors };
  },
};

